// 里の店の1画面：米問屋（#/komedoiya）・万屋（#/yorozuya）。中身は ui/komedoiya.ts・ui/yorozuya.ts
import { register } from '../router';
import { mountKomedoiya } from '../ui/komedoiya';
import { mountYorozuya } from '../ui/yorozuya';

register('komedoiya', { title: '米問屋', nav: 'village', mount: (el) => mountKomedoiya(el) });
register('yorozuya', { title: '万屋', nav: 'village', mount: (el) => mountYorozuya(el) });
